export const SET_USER = 'SET_MS_USER';
